module.exports = __webpack_public_path__ + "static/media/facebook-inscription.b360f291.png";